import { supabase } from "@/supabase";
import { ref } from "vue";
import { StorageService } from "./storage.service";
import { storage_url } from "../utils/general";
import { _DEFAULT_PERMISSIONS } from "./brand.service";

const _USERS = "users";

export const subscribedUsers = ref({});
export const UsersService = {
 async getUser(id) {
  const resp = { user: null, error: null };
  const { data: user, error } = await supabase
   .from(_USERS)
   .select("*,brand(*,company(*)),staff(*)")
   .eq("id", id)
   .single();
  if (error) {
   resp.error = error.message;
   return resp;
  }
  if (user) {
   if (user.avatar) {
    user.avatar = storage_url + user.avatar;
   }
   if(user.brand) {
   if (user.brand?.permissions == null) {
    user.brand.permissions = _DEFAULT_PERMISSIONS;
   }
   if (user.brand?.logo) {
    if (!user.brand.logo.startsWith('http')) {
        user.brand.logo = storage_url + user.brand.logo;
    }   
   }
   if (user.brand?.company?.logo) {
    if (!user.brand.company.logo.startsWith('http')) {
        user.brand.company.logo = storage_url + user.brand.company.logo;
    }
   }
    }
   resp.user = user;
   return resp;
  }
  return resp;
 },
 async getUsers(filter = {}, orderBy = {}) {
  const resp = { data: null, count: 0, error: null };
  try {
   const query = supabase.from(_USERS).select("*", { count: "exact" });
   if (filter.email) {
    query.filter("email", "ilike", `%${filter.search_email}%`);
   }
   if (filter.user_type) {
    query.filter("user_type", "eq", `${filter.user_type}`);
   }

   if (orderBy && orderBy.field) {
    query.order(orderBy.field, {
     ascending: orderBy.order === "asc" ? true : false,
    });
   }
   const { data, count, error } = await query;
   if (error) {
    resp.error = error.message;
    return resp;
   }
   if (data == null) {
    return resp;
   }
   for (const user of data) {
    if (user.avatar) {
     user.avatar = storage_url + user.avatar;
    }
   }
   resp.data = data;
   resp.count = count;
   return resp;
  } catch (err) {
   resp.error = err.message;
   return resp;
  }
 },
 async updateUser(data) {
  const resp = { updated: false, error: null };
  const { data: userObj, error: userObjError } = await this._getUserObject(
   data
  );

  if (userObjError) {
   resp.error = userObjError;
   return resp;
  }
  if (userObj) {
   const { error: userError } = await supabase
    .from(_USERS)
    .update(userObj)
    .eq("id", data.id)
    .single();

   if (userError) {
    resp.error = userError;
    return resp;
   }
  }
  resp.updated = true;
  return resp;
 },
 async _getUserObject(data) {
  const resp = { data: null, error: null };
  if (data.avatar_file) {
   const { data: file, error } = await StorageService.upload(
    data.avatar_file,
    "avatar"
   );
   if (error) {
    resp.error = error.message;
    return resp;
   }
   if (file) {
    if (data) {
     data.avatar = file.path;
    }
   }
  }

  const userObj = {};
  if ("first_name" in data) userObj.first_name = data.first_name;
  if ("last_name" in data) userObj.last_name = data.last_name;
  if ("avatar" in data) userObj.avatar = data.avatar;
  if ("user_type" in data) userObj.user_type = data.user_type;
  if ("status" in data) userObj.status = data.status;
  if ("current_brand_id" in data)
   userObj.current_brand_id = data.current_brand_id;
  resp.data = userObj;
  return resp;
 },
};
